<template>
  <BaseSvg class="next-icon" viewBox="0 0 11 21" fill="none">
    <path
      d="M1.5625 20L10 10.6314L1.5625 1.26282"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </BaseSvg>
</template>

<script>
import { BaseSvg } from '@clovyr/bed';

export default {
  name: 'NextIcon',
  components: {
    BaseSvg,
  },
};
</script>
<style scoped lang="scss">
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/colors';
@use 'styles/core/layout/grid-vars';

.next-icon {
  width: grid-vars.space(1.1);
  height: grid-vars.space(2.1);
  stroke: colors.color(grey, tertiary);
}
</style>
